import { render, staticRenderFns } from "./h1h2Comparison.vue?vue&type=template&id=798e2a55"
import script from "./h1h2Comparison.vue?vue&type=script&lang=js"
export * from "./h1h2Comparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports